import * as React from "react";
const SvgFiRrTrashClock = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-trash-clock_svg__a)">
      <path
        fill="#062147"
        d="M9 22h-.866a2.99 2.99 0 0 1-2.986-2.713L3.871 6h14.236l-.086.905a.999.999 0 1 0 1.99.19L20.115 6h.886a1 1 0 1 0 0-2H16.9a5.01 5.01 0 0 0-4.899-4h-2a5.01 5.01 0 0 0-4.899 4H1a1 1 0 1 0 0 2h.861l1.296 13.479A4.98 4.98 0 0 0 8.134 24H9a1 1 0 1 0 0-2m1-20h2c1.304 0 2.415.836 2.828 2H7.172A3 3 0 0 1 10 2m7 8c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7m0 12c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5m1.707-4.707a.999.999 0 1 1-1.414 1.414l-1-1A1 1 0 0 1 16 17v-2a1 1 0 1 1 2 0v1.586z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-trash-clock_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTrashClock;
